import React from "react";
import PropTypes from "prop-types";

const CardLongTitle = ({ title = "", className = "" }) => {
  return <div className={`card__title ${className}`}>{title}</div>;
};

CardLongTitle.propTypes = {
  title: PropTypes.string
};

export default CardLongTitle;
